import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { BbotButton, BbotModal, Checkbox, Table } from "top-component-library";

const HOSTNAME_COLUMNS = [
  { title: "Domain Name", dataIndex: "hostname", key: "hostname" },
  { title: "Domain Aliases", dataIndex: "hostnameAliases", key: "hostnameAliases" },
];

// Mirrors edit-party-tab-domain-restrictions-dialog.html: the checkbox is the inverse of
// tabs_work_anywhere (checked = restricted to owned domains), and the table is read-only,
// just context for which domains the restriction would apply to.
const PartyTabDomainRestrictionsDialog = ({ visible, tabsWorkAnywhere, hostnameConfigs, onClose, onSave }) => {
  const [restrictToOwnedDomains, setRestrictToOwnedDomains] = useState(!tabsWorkAnywhere);
  const [saving, setSaving] = useState(false);
  const plural = hostnameConfigs.length > 1;

  useEffect(() => {
    if (visible) setRestrictToOwnedDomains(!tabsWorkAnywhere);
  }, [visible, tabsWorkAnywhere]);

  const handleSave = async () => {
    setSaving(true);
    const success = await onSave(!restrictToOwnedDomains);
    setSaving(false);
    if (success) onClose();
  };

  return (
    <BbotModal
      title="Party Tab Domain Restrictions"
      visible={visible}
      onCancel={onClose}
      footer={[
        <BbotButton key="cancel" onClick={onClose}>
          Cancel
        </BbotButton>,
        <BbotButton key="save" type="primary" loading={saving} onClick={handleSave}>
          Save Changes
        </BbotButton>,
      ]}
    >
      <p>
        You can restrict party tabs opened on your site{plural ? "s" : ""} so they can only be used on the domain
        {plural ? "s" : ""} that you own.
      </p>
      <p>
        Note: Only use this restriction if you want to limit party tabs. TOP by DoorDash party tabs are associated with
        the guest, and they generally should not be restricted.
      </p>
      <Checkbox checked={restrictToOwnedDomains} onChange={(event) => setRestrictToOwnedDomains(event.target.checked)}>
        Restrict the use of party tabs opened on {plural ? "the following" : "this"} domain{plural ? "s" : ""}:
      </Checkbox>
      <Table
        dataSource={hostnameConfigs}
        columns={HOSTNAME_COLUMNS}
        rowKey="hostname"
        pagination={false}
        style={{ marginTop: 16 }}
      />
    </BbotModal>
  );
};

PartyTabDomainRestrictionsDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  tabsWorkAnywhere: PropTypes.bool.isRequired,
  hostnameConfigs: PropTypes.arrayOf(
    PropTypes.shape({ hostname: PropTypes.string.isRequired, hostnameAliases: PropTypes.string.isRequired })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default PartyTabDomainRestrictionsDialog;
